'use client';

import { useEffect, useState } from 'react';
import { detectTestMode } from '@/utils/test-mode';

export function TestModeBadge() {
  const [isTestMode, setIsTestMode] = useState(false);

  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;
    
    // Check test mode on mount
    setIsTestMode(detectTestMode());

    // Check periodically in case it changes
    const interval = setInterval(() => {
      setIsTestMode(detectTestMode());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  if (!isTestMode) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        backgroundColor: 'rgba(0, 0, 0, 0.06)', // Very subtle gray
        color: 'rgba(0, 0, 0, 0.4)', // Muted text
        padding: '4px 10px',
        borderRadius: '12px', // Pill shape
        fontSize: '11px', // Smaller, more discrete
        fontWeight: '500', // Medium weight, not bold
        zIndex: 9999,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        letterSpacing: '0.5px',
        transition: 'opacity 0.2s ease',
        opacity: 0.7,
        cursor: 'default',
        userSelect: 'none'
      }}
      onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
      onMouseLeave={(e) => e.currentTarget.style.opacity = '0.7'}
    >
      Test
    </div>
  );
}